import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import RelatedActivity, {
  ResponseSource
} from "@/components/controls/Questions/DreamerIndication/components/RelatedActivity";
import { EntityType } from "@/services/hooks/entities/useEntityType";

const TRANSLATION_KEY = "deals.dealView.filledByDreamer";

interface Props {
  entityType: EntityType;
  entityId: string;
  response: ResponseSource | null | undefined;
}

const ResponseSources: React.FC<Props> = ({
  entityType,
  entityId,
  response
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      {response && response?.activityId ? (
        <>
          <Text variant="bodySecondary">
            {t(`${TRANSLATION_KEY}.singleSource`)}
          </Text>
          <RelatedActivity
            entityType={entityType}
            entityId={entityId}
            response={response}
          />
        </>
      ) : (
        <Text variant="bodySecondary">{t(`${TRANSLATION_KEY}.noSources`)}</Text>
      )}
    </div>
  );
};

export default ResponseSources;
